import React, { useState } from "react";
import { withRedux, priceToDollars } from "helpers";
import * as styles from "../../../../newStyles.styles";
import styled from "react-emotion";
import Radio from "@material-ui/core/Radio";
import { withStyles } from "@material-ui/core/styles";

const OptionContainer = styled("div")`
  border-radius: 8px;
  border: ${(props) =>
    props.selected ? "2px solid " + props.color : "1px solid #dadada"};
  background-color: #f3f5f6;
  margin: 10px 0 20px;
  cursor: pointer;
  padding: 10px 15px;
  max-width: 400px;
  overflow-wrap: break-word;
  text-align: left;
`;

function DeliveryOptions(props) {
  if (!props.webStore.options) return null;
  const [selected, setSelected] = useState(props.cart.orderDeliveryType);

  const {
    webStore: {
      options: {
        pickupAvailable,
        pickupAddress,
        postPickupOrderNotes,
        deliveryAvailable,
        additionalDeliveryCost,
        deliveryCenterPoint,
        deliveryRadius,
        postDeliveryOrderNotes,
        shippingAvailable,
        additionalShippingCost,
        postShippingOrderNotes,
      },
    },
    cart,
    toggleAddressModal,
  } = props;
  const { navBarColor } = props.activeApp.view.navigation.navBarColor;

  const StyledRadio = withStyles({
    root: { color: navBarColor },
  })(Radio);

  const handleSelected = (option) => {
    switch (option) {
      case "PICKUP":
        setSelected("PICKUP");
        props.actions.setDeliveryMethod("PICKUP", 0);
        break;
      case "DELIVERY":
        setSelected("DELIVERY");
        props.actions.setDeliveryMethod("DELIVERY", additionalDeliveryCost);
        toggleAddressModal();
        break;
      case "SHIPPING":
        setSelected("SHIPPING");
        props.actions.setDeliveryMethod("SHIPPING", additionalShippingCost);
        toggleAddressModal();
        break;
      default:
        break;
    }
  };

  const renderPickupOption = () => {
    if (pickupAvailable) {
      return (
        <div style={{ display: "flex" }}>
          <StyledRadio
            type="radio"
            id="PICKUP"
            color="primary"
            name="deliveryOption"
            value="PICKUP"
            style={{ marginRight: "10px" }}
            checked={selected === "PICKUP"}
            onChange={() => handleSelected("PICKUP")}
          />
          <OptionContainer
            onClick={() => handleSelected("PICKUP")}
            selected={selected === "PICKUP"}
            color={props.activeApp.view.navigation.navBarColor}
          >
            <styles.P
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Pickup
            </styles.P>
            {pickupAddress && (
              <styles.P>Pickup location: {pickupAddress.fullAddress}</styles.P>
            )}
            {postPickupOrderNotes && (
              <styles.P>Note from business: {postPickupOrderNotes}</styles.P>
            )}
          </OptionContainer>
        </div>
      );
    }
  };

  const renderDeliveryOption = () => {
    if (deliveryAvailable) {
      return (
        <div style={{ display: "flex" }}>
          <Radio
            type="radio"
            id="DELIVERY"
            name="deliveryOption"
            color="primary"
            value="DELIVERY"
            style={{ marginRight: "10px" }}
            checked={selected === "DELIVERY"}
            onChange={() => handleSelected("DELIVERY")}
          />
          <OptionContainer
            onClick={() => handleSelected("DELIVERY")}
            selected={selected === "DELIVERY"}
            color={props.activeApp.view.navigation.navBarColor}
          >
            <styles.P
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Delivery -{" "}
              {additionalDeliveryCost === 0 || additionalDeliveryCost === null
                ? "Free"
                : priceToDollars(additionalDeliveryCost)}
            </styles.P>
            {deliveryRadius && deliveryCenterPoint && (
              <styles.P>
                We delivery only within {deliveryRadius} miles of{" "}
                {deliveryCenterPoint.fullAddress}
              </styles.P>
            )}
            {postDeliveryOrderNotes && (
              <styles.P>Note from business: {postDeliveryOrderNotes}</styles.P>
            )}
          </OptionContainer>
        </div>
      );
    }
  };

  const renderShippingOption = () => {
    if (shippingAvailable) {
      return (
        <div style={{ display: "flex" }}>
          <Radio
            type="radio"
            id="SHIPPING"
            name="deliveryOption"
            color="primary"
            value="SHIPPING"
            style={{ marginRight: "10px" }}
            checked={selected === "SHIPPING"}
            onChange={() => handleSelected("SHIPPING")}
          />
          <OptionContainer
            onClick={() => handleSelected("SHIPPING")}
            selected={selected === "SHIPPING"}
            color={props.activeApp.view.navigation.navBarColor}
          >
            <styles.P
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Shipping -{" "}
              {additionalShippingCost === 0 || additionalShippingCost === null
                ? "Free"
                : priceToDollars(additionalShippingCost)}
            </styles.P>
            {postShippingOrderNotes && (
              <styles.P>Note from business: {postShippingOrderNotes}</styles.P>
            )}
          </OptionContainer>
        </div>
      );
    }
  };

  // console.log(selected);

  return (
    <div>
      {renderPickupOption()}
      {renderDeliveryOption()}
      {renderShippingOption()}
    </div>
  );
}

export default withRedux(DeliveryOptions);
